import React, { Component } from "react";
import Header from "./Header";
import HeaderIntro from "./HeaderIntro";
import Footer from "./Footer";
import NewsLetter from "./NewsLetter";
export class ExpertAssistedefiling extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
        <div className="container" >
          <div class="container-fluid" data-aos="fade-up">
             <div class="section-header">
              <h3>Expert Assisted E-Filing</h3>
              <p>
              ClipTax provides you a wide array of services related to
                Taxation with special services from our Experts and Chartered
                Accountants. Our services and expertise is what separates us
                from others. 
              </p>
            </div>
           
          </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default ExpertAssistedefiling;
